<template lang="pug">
GreyPage
  .upsert-page.w-1050
    .title-bar.mb-L
      h1.h1(data-test-id="title") {{ title }}
    .tabs-bar
      BriqPanel
        .flex
          form(@submit.prevent="submit")
            ul.tab-links
              li.tab-link(
                v-for="tabName in tabNames"
                :data-test-id="`tab-${tabName.toLowerCase()}`"
                :key="tabName"
                :class="{active: tabName === activeTab}"
                @click="activeTab = tabName"
                ) {{ tabName }}
          .buttons
            BriqButton(variant="text" @click="$emit('cancel')" :disabled="disabled" data-test-id="cancel-button-top") Cancel
            BriqViewAuditTrail(v-if="showAuditTrail" :objectType="objectType" :objectKey="objectKey")
            BriqSubmitButton(
              data-test-id="submit-button"
              @click="$emit('save')"
              :disabled="disableSave"
              :pending="pending"
              ) {{ saveLabel }}
    slot(:name="`tab-${activeTab.toLowerCase()}`")
    .buttons-bottom
      BriqButton(variant="text" @click="$emit('cancel')" :disabled="disabled" data-test-id="cancel-button-bottom") Cancel
      BriqSubmitButton(
        data-test-id="submit-button-2"
        @click="$emit('save')"
        :disabled="disableSave"
        :pending="pending"
        ) {{ saveLabel }}
</template>

<script>
export default {
  props: {
    title: String,
    disabled: Boolean,
    canSave: {
      type: Boolean,
      default: true,
    },
    saveLabel: {
      type: String,
      default: 'Save changes',
    },
    tabNames: Array,
    pending: Boolean,
    showAuditTrail: Boolean,
    objectType: String,
    objectKey: String,
  },
  data() {
    return {
      activeTab: this.tabNames[0],
    }
  },
  computed: {
    disableSave() {
      return this.disabled || !this.canSave
    },
  },
  methods: {
    submit() {
      if (!this.disableSave && !this.pending) this.$emit('save')
    },
  },
}
</script>

<style lang="stylus">
.tabs-bar
  display contents

  .briq-panel
    display flex
    justify-content space-between
    padding 24px 32px

.tab
  display none

.tab:target
  display default

.buttons > .briq-button
  margin-left 8px

.buttons-bottom > .briq-button:first-child
  margin-right 16px
</style>

<style scoped lang="stylus">
.tab-links
  font-weight bold
  list-style none
  display flex
  padding 0
  margin 0

  .tab-link
    height 100%
    padding 10px
    box-sizing border-box
    display inline-block
    cursor pointer

    &:hover
      color #888

    &.active
      color #009BFF

.buttons-bottom
  display flex
  justify-content center

.buttons
  display flex

.flex
  display: flex;
  justify-content: space-between;
</style>
